import { Injectable } from '@angular/core';

@Injectable()
export class WorkflowService{

    wguPolicyAcknowledge: boolean=false
    identity: {first_name: string,
        last_name: string,
        claim_code: string,
        user_type: string,
    }

    getWguPolicyAcknowledge() {
        // console.log("Service wguPolicyAcknowledge " + this.wguPolicyAcknowledge)
        if (localStorage.getItem('wguPolicyAcknowledge')){
            let check_local_wguPolicy = localStorage.getItem('wguPolicyAcknowledge');
            if (check_local_wguPolicy == 'true'){
                this.wguPolicyAcknowledge = true;
            } else {
                this.wguPolicyAcknowledge = false;
            }
        }
        return this.wguPolicyAcknowledge === true;
    }

    setWguPolicyAcknowledge() {
        this.wguPolicyAcknowledge = true;
        localStorage.setItem('wguPolicyAcknowledge', JSON.stringify(this.wguPolicyAcknowledge));
        return this.wguPolicyAcknowledge
    }

    unSetWguPolicyAcknowledge() {
        return this.wguPolicyAcknowledge = false;
    }

    setIdentity(firstName, lastName, claimCode, userType){
        this.identity = {first_name: firstName,
            last_name: lastName,
            claim_code: claimCode,
            user_type: userType
        };

        // console.log("claimIdentity" + JSON.stringify(this.identity))
        localStorage.setItem('claimIdentity', JSON.stringify(this.identity))
        return this.identity
    }
}